import { NgModule }             from '@angular/core';
import { FormsModule }          from '@angular/forms';
import { CommonModule }         from '@angular/common';
import { ModalComponent }       from '../common/modal.component';
import { GooglemapComponent }   from '../common/googlemap.component';
import { PaginationComponent }  from '../common/pagination.component';
import { AgmCoreModule }        from '@agm/core';
import { AgmDirectionModule }   from 'agm-direction';


@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        AgmCoreModule,
        AgmDirectionModule
    ],
    exports: [
        ModalComponent,
        PaginationComponent,
        GooglemapComponent
    ],
    declarations: [
        ModalComponent,
        PaginationComponent,
        GooglemapComponent
    ],
    providers: [  ]
})
export class CommonToolModule {}



// WEBPACK FOOTER //
// ./src/app/common/common-tool.module.ts